export default __webpack_public_path__ + "static/media/selected-pin.49ab64f8.svg";